import type { DefaultTheme } from 'styled-components';
import commonStyles from './common';

export const light: DefaultTheme = {
	...commonStyles,
	colors: {
		main: '#FF9E45',
		red: '#FF6745',
		blue: '#459BFF',
		green: '#70BC78',
		background: '#FFF',
		secondary: '#F8F8F8',
		primaryText: '#000',
		secondaryText: '#C58E2D',
		borderColor: '#d9d9d9',
		inputColor: '#eee',
		placeholderText: '#333',
		disabledColor: '#ddd',
		hoverColor: '#F4F4F5'
	}
};
